import Flex from '@eversports/react-components/primitives/Flex'
import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import Text from '@eversports/react-components/primitives/Text'
import Processing from '@eversports/react-components/primitives/Processing'
import { useLocation } from 'react-router-dom'
import { Localized } from '../../localization/react'
import { SpecialPriceType, useCorporateInfoItemCartQuery } from '../../graphql'
import { PriceTableItemSpecialPrice } from '../../typings/PriceTable'
import getPhoenixUrlParams from '../../lib/get-phoenix-url-params'

interface Props {
  item: PriceTableItemSpecialPrice
}

const SpecialPriceSummaryItem = ({ item }: Props) => {
  const location = useLocation()
  const { cartId, orderId } = getPhoenixUrlParams(location.search)

  const { data, loading } = useCorporateInfoItemCartQuery({
    variables: { cartId: cartId as string },
    skip: Boolean(orderId) || !cartId,
  })

  const corporatePartnerName = data?.cart.availableCorporateBenefits.corporatePartner?.name
  const isCorporateSpecialPrice = item.specialPriceType === SpecialPriceType.CORPORATE_EMPLOYEES

  if (!corporatePartnerName) {
    return null
  }

  return (
    <Processing isLoading={loading}>
      <Flex justifyContent="space-between">
        <Flex horizontalSpacing="dense" alignItems="center">
          <Text>
            {isCorporateSpecialPrice ? (
              <Localized id="corporate-pricing-discount-label" params={{ corporatePartnerName }} />
            ) : (
              item.name
            )}
          </Text>
        </Flex>
        <Text fontWeight="bold">
          {item.totalPrice && <MonetaryValue value={item.totalPrice.value} currencyCode={item.totalPrice.currency} />}
        </Text>
      </Flex>
    </Processing>
  )
}

export default SpecialPriceSummaryItem
